export const getUser = () => {
  try {
    const user = JSON.parse(localStorage.getItem("usersaarthi"));
    return typeof user?.emails?.[0]?.value === "string" && user.emails[0].value
      ? user
      : null;
  } catch {
    return null;
  }
};
